{
  "name": "Littletown",
  "ambient": 8093324,
  "light": 5461350,
  "sky": 6716054,
  "fog": 7832738,
  "fogD": 722.1829102596926,
  "nAmb": 1,
  "camPos": [36, 53, 252],
  "spawns": [[424, 0, -102, 0, 2, 0], [-276, 0, 12, 0, 3, 0], [-274, 0, 186, 0, 3, 0], [287, 38, 32, 0, 2, 0], [-156, 38, 33, 0, 3, 0], [-95, 38, -4, 0, 0, 0], [384, 0, 87, 0, 2, 0], [141, 0, 337, 0, 2, 0]],
  "ambO": 0.7,
  "ambS": 5,
  "objects": [{
    "p": [138, 2, 6],
    "s": [4, 36, 60],
    "c": 12927811,
    "t": 5
  }, {
    "p": [205, 36, 30],
    "s": [62, 2, 108],
    "c": 7368816,
    "t": 5
  }, {
    "p": [238, 38, 45],
    "s": [4, 38, 74],
    "c": 16767158,
    "t": 5
  }, {
    "p": [170, 2, 123],
    "s": [30, 116, 18],
    "c": 7368816,
    "t": 11,
    "bo": 1
  }, {
    "p": [-65, 2, 69],
    "s": [4, 30, 10],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [304, 2, -7],
    "s": [2, 52, 12],
    "i": 3,
    "t": 2
  }, {
    "p": [138, 38, 3],
    "s": [4, 6, 38],
    "c": 12927811,
    "t": 5
  }, {
    "p": [138, 38, 81],
    "s": [4, 6, 34],
    "c": 12927811,
    "t": 5
  }, {
    "p": [138, 38, 43],
    "s": [4, 46, 42],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [138, 38, 104],
    "s": [4, 40, 12],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [138, 38, -20],
    "s": [4, 51, 8],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [138, 66, 3],
    "s": [4, 21, 38],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [138, 2, 81],
    "s": [4, 36, 58],
    "c": 12927811,
    "t": 5
  }, {
    "p": [138, 26, 44],
    "s": [4, 12, 16],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [220, 2, 112],
    "s": [168, 74, 4],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [205, 2, -26],
    "s": [138, 88, 4],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [297, 2, -26],
    "s": [14, 88, 4],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [282, 26, -26],
    "s": [16, 64, 4],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [302, 38, 16],
    "s": [4, 46, 80],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [302, 79, 74],
    "s": [4, 3, 4],
    "c": 12927811,
    "t": 5
  }, {
    "p": [302, 62, 64],
    "s": [4, 20, 16],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [302, 2, 25],
    "s": [4, 36, 98],
    "c": 12927811,
    "t": 5
  }, {
    "p": [302, 2, 100],
    "s": [4, 36, 20],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [302, 26, 82],
    "s": [4, 12, 16],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [238, 38, -16],
    "s": [4, 38, 16],
    "c": 16767158,
    "t": 5
  }, {
    "p": [238, 64, 0],
    "s": [4, 12, 16],
    "c": 16767158,
    "t": 5
  }, {
    "p": [176, 34, 98],
    "s": [4, 42, 24],
    "c": 16767158,
    "t": 5
  }, {
    "p": [291, 38, 84],
    "s": [18, 38, 4],
    "c": 16767158,
    "t": 5
  }, {
    "p": [262, 38, 84],
    "s": [8, 38, 4],
    "c": 16767158,
    "t": 5
  }, {
    "p": [274, 62, 84],
    "s": [16, 14, 4],
    "c": 16767158,
    "t": 5
  }, {
    "p": [216, 2, 84],
    "s": [84, 74, 4],
    "c": 16767158,
    "t": 5
  }, {
    "p": [256, 2, 98],
    "s": [4, 36, 24],
    "c": 16767158,
    "t": 5
  }, {
    "p": [238, 2, 67],
    "s": [4, 36, 30],
    "c": 16767158,
    "t": 5
  }, {
    "p": [238, 2, -5],
    "s": [4, 36, 38],
    "c": 16767158,
    "t": 5
  }, {
    "p": [238, 26, 33],
    "s": [4, 12, 38],
    "c": 16767158,
    "t": 5
  }, {
    "p": [157, 36, 43],
    "s": [34, 2, 134],
    "c": 7368816,
    "t": 5
  }, {
    "p": [270, 36, 30],
    "s": [60, 2, 108],
    "c": 7368816,
    "t": 5
  }, {
    "p": [279, 36, 97],
    "s": [42, 2, 26],
    "c": 7368816,
    "t": 5
  }, {
    "p": [220, 0, 43],
    "s": [172, 2, 146],
    "c": 7368816,
    "t": 5
  }, {
    "p": [183, 0, -75],
    "s": [150, 2, 98],
    "c": 7368816,
    "t": 5
  }, {
    "p": [158, 2, -31],
    "s": [4, 30, 6],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [158, 2, -74],
    "s": [4, 30, 4],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [158, 2, -117],
    "s": [4, 30, 2],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [158, 32, -73],
    "s": [4, 12, 90],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [254, 2, -60],
    "s": [4, 42, 64],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [254, 2, -113],
    "s": [4, 42, 10],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [254, 26, -100],
    "s": [4, 18, 16],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [206, 2, -120],
    "s": [100, 42, 4],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [158, 2, -96],
    "s": [2, 30, 42],
    "pe": 1,
    "c": "#ffffff",
    "t": 10
  }, {
    "p": [170, 0, 125],
    "s": [34, 2, 18],
    "c": 7368816,
    "t": 5
  }, {
    "p": [260, 0, -100],
    "s": [4, 2, 20],
    "c": 7368816,
    "t": 5
  }, {
    "p": [308, 0, 82],
    "s": [4, 2, 20],
    "c": 7368816,
    "t": 5
  }, {
    "p": [-41, 0, -24],
    "s": [4, 2, 20],
    "c": 7368816,
    "t": 5
  }, {
    "p": [282, 0, -32],
    "s": [20, 2, 4],
    "c": 7368816,
    "t": 5
  }, {
    "p": [29, -1, 323],
    "s": [106, 2, 845],
    "c": 3750201,
    "t": 5
  }, {
    "p": [-65, 32, 115],
    "s": [4, 12, 102],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [-65, 2, 115],
    "s": [4, 30, 10],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [-65, 2, 161],
    "s": [4, 30, 10],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [-145, 2, 161],
    "s": [4, 42, 10],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [-145, 2, 102],
    "s": [4, 42, 76],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [-105, 2, 168],
    "s": [84, 42, 4],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [-145, 26, 148],
    "s": [4, 18, 16],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [-65, 2, 139],
    "s": [2, 30, 42],
    "pe": 1,
    "t": 10
  }, {
    "p": [-91, 0, 118],
    "s": [116, 2, 108],
    "c": 7368816,
    "t": 5
  }, {
    "p": [-113, 0, -16],
    "s": [140, 2, 164],
    "c": 7368816,
    "t": 5
  }, {
    "p": [-142, 2, 62],
    "s": [30, 74, 4],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [-78, 2, 62],
    "s": [66, 74, 4],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [-113, 2, -94],
    "s": [136, 74, 4],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [-47, 66, -16],
    "s": [4, 10, 152],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [-47, 38, -77],
    "s": [4, 28, 30],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [-47, 38, -3],
    "s": [4, 28, 42],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [-47, 38, 35],
    "s": [4, 6, 34],
    "c": 5799880,
    "t": 5
  }, {
    "p": [-47, 38, -43],
    "s": [4, 6, 38],
    "c": 5799880,
    "t": 5
  }, {
    "p": [-47, 38, 56],
    "s": [4, 28, 8],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [-47, 2, -62],
    "s": [4, 36, 60],
    "c": 5799880,
    "t": 5
  }, {
    "p": [-47, 26, -24],
    "s": [4, 12, 16],
    "c": 5799880,
    "t": 5
  }, {
    "p": [-177, 2, 62],
    "s": [8, 74, 4],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [-179, 2, 5],
    "s": [4, 74, 110],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [-179, 2, -79],
    "s": [4, 74, 26],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [-119, 26, 62],
    "s": [16, 50, 4],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [-165, 26, 62],
    "s": [16, 50, 4],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [-140, 2, -80],
    "s": [4, 36, 24],
    "c": 16767158,
    "t": 5
  }, {
    "p": [-105, 2, -66],
    "s": [74, 74, 4],
    "c": 16767158,
    "t": 5
  }, {
    "p": [-70, 34, -80],
    "s": [4, 42, 24],
    "c": 16767158,
    "t": 5
  }, {
    "p": [-179, 26, -58],
    "s": [4, 12, 16],
    "c": 5799880,
    "t": 5
  }, {
    "p": [-58, 36, -16],
    "s": [20, 2, 152],
    "c": 7368816,
    "t": 5
  }, {
    "p": [-134, 2, 32],
    "s": [4, 28, 56],
    "c": 16767158,
    "t": 5
  }, {
    "p": [-134, 2, -49],
    "s": [4, 28, 30],
    "c": 16767158,
    "t": 5
  }, {
    "p": [-134, 30, -2],
    "s": [4, 8, 124],
    "c": 16767158,
    "t": 5
  }, {
    "p": [-100, 36, -2],
    "s": [64, 2, 124],
    "c": 7368816,
    "t": 5
  }, {
    "p": [-157, 36, -3],
    "s": [42, 2, 126],
    "c": 7368816,
    "t": 5
  }, {
    "p": [-160, 36, -79],
    "s": [36, 2, 26],
    "c": 7368816,
    "t": 5
  }, {
    "p": [-179, 62, -58],
    "s": [4, 14, 16],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [-134, 38, -57],
    "s": [4, 38, 14],
    "c": 16767158,
    "t": 5
  }, {
    "p": [-134, 38, 13],
    "s": [4, 38, 94],
    "c": 16767158,
    "t": 5
  }, {
    "p": [-134, 60, -42],
    "s": [4, 16, 16],
    "c": 16767158,
    "t": 5
  }, {
    "p": [337, -2, 99],
    "s": [4, 40, 4],
    "pe": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [306, -2, 99],
    "s": [4, 40, 4],
    "pe": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [337, -2, 5],
    "s": [4, 40, 4],
    "pe": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [306, -2, 5],
    "s": [4, 40, 4],
    "pe": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [322, 34, 52],
    "s": [36, 2, 100],
    "pe": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [-199, 34, -47],
    "s": [36, 2, 82],
    "pe": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [-214, -1, -9],
    "s": [4, 38, 4],
    "pe": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [-214, -1, -85],
    "s": [4, 38, 4],
    "pe": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [-183, -1, -85],
    "s": [4, 38, 4],
    "pe": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [-183, -1, -9],
    "s": [4, 38, 4],
    "pe": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [132, 0, 44],
    "s": [4, 2, 20],
    "c": 7368816,
    "t": 5
  }, {
    "p": [-185, 0, -58],
    "s": [4, 2, 20],
    "c": 7368816,
    "t": 5
  }, {
    "p": [-151, 0, 148],
    "s": [4, 2, 20],
    "c": 7368816,
    "t": 5
  }, {
    "p": [-165, 0, 68],
    "s": [18, 2, 4],
    "c": 7368816,
    "t": 5
  }, {
    "p": [-113, 76, -16],
    "s": [146, 4, 170],
    "c": 5263440,
    "t": 5,
    "bo": 1
  }, {
    "p": [-105, 44, 119],
    "s": [94, 4, 112],
    "c": 5263440,
    "t": 5,
    "bo": 1
  }, {
    "p": [220, 75, 42],
    "s": [165, 4, 137],
    "c": 5263440,
    "t": 5,
    "bo": 1
  }, {
    "p": [206, 44, -77],
    "s": [108, 4, 98],
    "c": 5263440,
    "t": 5,
    "bo": 1
  }, {
    "p": [-79, 2, -105],
    "s": [30, 118, 18],
    "c": 7368816,
    "t": 11,
    "bo": 1
  }, {
    "p": [-79, 0, -107],
    "s": [34, 2, 18],
    "c": 7368816,
    "t": 5
  }, {
    "p": [32, 2, -207],
    "s": [124, 74, 150],
    "c": 12958048,
    "t": 5,
    "bo": 1
  }, {
    "p": [32, 74, -207],
    "s": [136, 4, 162],
    "c": 5263440,
    "t": 5,
    "bo": 1
  }, {
    "p": [32, 0, -207],
    "s": [128, 2, 154],
    "c": 7368816,
    "t": 5
  }, {
    "p": [94, -1, 159],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [94, -1, 217],
    "s": [2, 24, 113],
    "pe": 1,
    "c": 7692103,
    "t": 10,
    "bo": 1
  }, {
    "p": [246, -1, 159],
    "s": [302, 24, 2],
    "pe": 1,
    "c": 7692103,
    "t": 10,
    "bo": 1
  }, {
    "p": [-37, -1, 235],
    "s": [2, 24, 58],
    "c": 7692103,
    "t": 10,
    "bo": 1
  }, {
    "p": [-37, -1, 205],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [-163, -1, 205],
    "s": [254, 24, 2],
    "c": 7692103,
    "t": 10,
    "bo": 1
  }, {
    "p": [398, -1, 159],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [399, -1, 59],
    "s": [2, 24, 206],
    "c": 7692103,
    "t": 10,
    "bo": 1
  }, {
    "p": [399, -1, -156],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [260, -1, -157],
    "s": [340, 24, 2],
    "c": 7692103,
    "t": 10,
    "bo": 1
  }, {
    "p": [-161, -1, -157],
    "s": [262, 24, 2],
    "c": 7692103,
    "t": 10,
    "bo": 1
  }, {
    "p": [-290, -1, 204],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [-291, -1, 24],
    "s": [2, 24, 358],
    "c": 7692103,
    "t": 10,
    "bo": 1
  }, {
    "p": [-290, -1, -156],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [-181, 2, 3],
    "s": [2, 52, 12],
    "i": 3,
    "t": 2,
    "d": 2
  }, {
    "p": [32, 0, -121],
    "s": [48, 2, 18],
    "c": 7368816,
    "t": 5
  }, {
    "p": [32, 39, -123],
    "s": [46, 3, 19],
    "l": 1,
    "c": 5263440,
    "t": 5
  }, {
    "p": [-251, -1, 173],
    "s": [2, 24, 63],
    "pe": 1,
    "c": 7692103,
    "t": 10
  }, {
    "p": [-267, 0, 73],
    "s": [46, 30, 42],
    "c": 5799880,
    "t": 5
  }, {
    "p": [-267, 30, 73],
    "s": [54, 2, 50],
    "c": 5395026,
    "t": 5
  }, {
    "p": [343, 0, -138],
    "s": [52, 32, 36],
    "c": 12927811,
    "t": 5
  }, {
    "p": [343, 32, -138],
    "s": [56, 2, 40],
    "c": 5263440,
    "t": 5
  }, {
    "p": [399, -1, -46],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [416, -1, -45],
    "s": [30, 24, 2],
    "c": 7692103,
    "t": 10,
    "bo": 1
  }, {
    "p": [431, -1, -46],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [432, -1, -101],
    "s": [2, 24, 110],
    "c": 7692103,
    "t": 10,
    "bo": 1
  }, {
    "p": [431, -1, -156],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [-250, -1, 16],
    "s": [8, 24, 72],
    "pe": 1,
    "c": 6984507,
    "t": 5
  }, {
    "p": [-213, -1, -120],
    "s": [8, 10, 20],
    "pe": 1,
    "c": 6984507,
    "t": 5
  }, {
    "p": [-232, 26, -143],
    "s": [58, 2, 32],
    "c": 7039851,
    "t": 5
  }, {
    "p": [-232, 0, -143],
    "s": [52, 26, 26],
    "c": 5799880,
    "t": 5
  }, {
    "p": [-233, -1, 86],
    "s": [22, 10, 8],
    "pe": 1,
    "c": 6984507,
    "t": 5
  }, {
    "p": [313, -1, -134],
    "s": [8, 10, 44],
    "c": 6984507,
    "t": 5
  }, {
    "p": [-144, -1, -154],
    "s": [124, 10, 5],
    "c": 6984507,
    "t": 5
  }, {
    "p": [435, 0, -16],
    "s": [52, 32, 36],
    "c": 12927811,
    "t": 5
  }, {
    "p": [435, 32, -16],
    "s": [56, 2, 40],
    "c": 5263440,
    "t": 5
  }, {
    "p": [399, -2, -100],
    "s": [8, 20, 56],
    "pe": 1,
    "c": 6984507,
    "t": 5
  }, {
    "p": [342, -1, 52],
    "s": [6, 10, 104],
    "pe": 1,
    "c": 6984507,
    "t": 5
  }, {
    "p": [-251, -1, 205],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [-251, -1, 106],
    "s": [2, 24, 25],
    "pe": 1,
    "c": 7692103,
    "t": 10
  }, {
    "p": [151, 2, -99],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [340, 0, -114],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [108, 0, 152],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [108, 12, 152],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [191, 2, -112],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [246, 2, -50],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-137, 2, 116],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-104, 2, 160],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-56, 0, 198],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-56, 12, 198],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-140, 2, 106],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [249, 2, -59],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-202, 0, -148],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-92, 2, 160],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [203, 2, -112],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [130, 34, 79],
    "s": [12, 2, 42],
    "pe": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [136, 2, 105],
    "s": [2, 42, 8],
    "i": 3,
    "t": 2,
    "d": 2
  }, {
    "p": [-47, 44, 35],
    "s": [1, 22, 34],
    "pe": 1,
    "c": 9533019,
    "t": 10
  }, {
    "p": [-219, -1, 176],
    "s": [4, 32, 4],
    "pe": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-219, 30, 176],
    "s": [26, 26, 28],
    "c": 6193707,
    "t": 5,
    "bo": 1
  }, {
    "p": [-219, 20, 181],
    "s": [2, 2, 8],
    "pe": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-219, 19, 188],
    "s": [6, 6, 8],
    "pe": 1,
    "c": 6193707,
    "t": 5,
    "bo": 1
  }, {
    "p": [-224, 18, 176],
    "s": [6, 2, 2],
    "pe": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-229, 17, 176],
    "s": [6, 4, 6],
    "pe": 1,
    "c": 6193707,
    "t": 5,
    "bo": 1
  }, {
    "p": [375, -1, 138],
    "s": [4, 32, 4],
    "pe": 1,
    "c": 6574655,
    "t": 5,
    "bo": 1
  }, {
    "p": [375, 29, 138],
    "s": [26, 26, 28],
    "c": 6193707,
    "t": 5,
    "bo": 1
  }, {
    "p": [375, 19, 133],
    "s": [2, 2, 8],
    "c": 6574655,
    "t": 5
  }, {
    "p": [375, 18, 127],
    "s": [6, 6, 8],
    "c": 6193707,
    "t": 5,
    "bo": 1
  }, {
    "p": [371, 15, 138],
    "s": [6, 2, 2],
    "c": 6574655,
    "t": 5
  }, {
    "p": [365, 14, 138],
    "s": [6, 4, 6],
    "c": 6193707,
    "t": 5,
    "bo": 1
  }, {
    "p": [37, 1, -78],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [49, 1, -78],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [44, 1, -66],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [41, 13, -78],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [130, 2, 51],
    "s": [16, 24, 2],
    "pe": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [-39, 2, -31],
    "s": [16, 24, 2],
    "pe": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [29, 1, 225],
    "s": [51, 15, 20],
    "i": 7,
    "l": 1
  }, {
    "p": [-125, -1, 175],
    "s": [4, 22, 2],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 7692103,
    "t": 5
  }, {
    "p": [-113, 0, 175],
    "s": [4, 22, 2],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 7692103,
    "t": 5
  }, {
    "p": [154, 2, -46],
    "s": [51, 15, 20],
    "i": 7,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-60, 2, 115],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [169, 0, -150],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [90, 0, 175],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [395, 0, 28],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-246, 0, 112],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [29, 1, 225],
    "s": [48, 8, 16],
    "v": 1,
    "t": 5
  }, {
    "p": [34, 8, 225],
    "s": [24, 8, 16],
    "v": 1,
    "t": 5
  }, {
    "p": [148, 9, -45],
    "s": [24, 8, 16],
    "v": 1,
    "t": 5
  }, {
    "p": [154, 3, -45],
    "s": [48, 8, 16],
    "v": 1,
    "t": 5
  }, {
    "p": [138, 44, 3],
    "s": [1, 22, 38],
    "pe": 1,
    "c": 7692103,
    "t": 10
  }, {
    "p": [117, 21, 180],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5
  }, {
    "p": [117, -1, 180],
    "s": [4, 28, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-64, -1, 235],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-64, 21, 235],
    "s": [26, 28, 28],
    "l": 1,
    "c": 7709238,
    "t": 5
  }, {
    "p": [-42, 23, 288],
    "s": [27, 28, 24],
    "pe": 1,
    "c": 6193707,
    "t": 5,
    "bo": 1
  }, {
    "p": [-37, -1, 265],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [94, -1, 275],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [-42, -1, 289],
    "s": [4, 31, 4],
    "pe": 1,
    "c": 6574655,
    "t": 5,
    "bo": 1
  }, {
    "p": [-315, -1, 13],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-321, -1, -132],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [459, 14, -62],
    "s": [26, 27, 35],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [207, 17, -188],
    "s": [26, 25, 28],
    "l": 1,
    "c": 5204775,
    "t": 5
  }, {
    "p": [-102, 16, -181],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5
  }, {
    "p": [-320, 19, 175],
    "s": [26, 28, 28],
    "l": 1,
    "c": 7709238,
    "t": 5
  }, {
    "p": [85, 0, 188],
    "s": [2, 73, 2],
    "c": 7368816,
    "t": 5
  }, {
    "p": [79, 71, 188],
    "s": [10, 2, 2],
    "c": 7368816,
    "t": 5
  }, {
    "p": [75, 70, 498],
    "s": [10, 2, 4],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [75, 69, 188],
    "s": [9, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [-27, 0, 332],
    "s": [2, 73, 2],
    "c": 7368816,
    "t": 5
  }, {
    "p": [-21, 71, 332],
    "s": [10, 2, 2],
    "c": 7368816,
    "t": 5
  }, {
    "p": [-17, 70, 332],
    "s": [10, 2, 4],
    "c": 7368816,
    "t": 5
  }, {
    "p": [-17, 69, 332],
    "s": [9, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [-9, 0, -104],
    "s": [2, 73, 2],
    "c": 7368816,
    "t": 5
  }, {
    "p": [-9, 71, -99],
    "s": [2, 2, 8],
    "c": 7368816,
    "t": 5
  }, {
    "p": [-9, 69, -96],
    "s": [2, 1, 8],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [-9, 70, -96],
    "s": [3, 2, 9],
    "c": 7368816,
    "t": 5
  }, {
    "p": [279, 15, 184],
    "s": [26, 28, 28],
    "l": 1,
    "c": 6193707,
    "t": 5
  }, {
    "p": [-321, 11, -132],
    "s": [26, 30, 28],
    "l": 1,
    "c": 7709238,
    "t": 5
  }, {
    "p": [230, 2, 2],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [246, 2, 62],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [246, 38, 28],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [190, 38, 76],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-126, 38, 36],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-171, 38, -16],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-126, 2, -58],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-55, 2, -1],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-84, 38, 56],
    "s": [4, 22, 2],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 7692103,
    "t": 5
  }, {
    "p": [-76, 38, 56],
    "s": [4, 22, 2],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 7692103,
    "t": 5
  }, {
    "p": [-96, 38, 56],
    "s": [4, 22, 2],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 7692103,
    "t": 5
  }, {
    "p": [-114, 39, 29],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, 0.52, 0],
    "c": 10987431,
    "t": 5
  }, {
    "p": [-81, 39, 47],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 11645361,
    "t": 5
  }, {
    "p": [-144, 39, -57],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 10658466,
    "t": 5
  }, {
    "p": [-109, 3, -53],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 11184810,
    "t": 5
  }, {
    "p": [60, 2, -62],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 9671571,
    "t": 5
  }, {
    "p": [8, 2, 178],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 10329501,
    "t": 5
  }, {
    "p": [-120, 38, 28],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [-67, 39, -59],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [-3.14, 1.05, -3.14],
    "c": 10987431,
    "t": 5
  }, {
    "p": [-120, 40, 28],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [-53, 38, 55],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [-53, 40, 55],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [-80, 38, -62],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [-80, 40, -62],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [-138, 38, -11],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [-138, 40, -11],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [-142, 39, -5],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [3.14, -1.04, 3.14],
    "c": 10658466,
    "t": 5
  }, {
    "p": [-89, 38, -58],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-70, 3, 108],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [-3.14, 1.05, -3.14],
    "c": 10987431,
    "t": 5
  }, {
    "p": [-86, 2, 66],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [-86, 4, 66],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [-106, 3, 127],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [-3.14, 1.05, -3.14],
    "c": 10987431,
    "t": 5
  }, {
    "p": [-103, 3, 119],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": 10987431,
    "t": 5
  }, {
    "p": [-92, 4, 58],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [-92, 2, 58],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [173, 2, -20],
    "s": [1, 8, 7],
    "pe": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [195, 2, -20],
    "s": [1, 8, 7],
    "pe": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [184, 9, -20],
    "s": [11, 1, 4],
    "pe": 1,
    "c": 3421236,
    "t": 5
  }, {
    "p": [184, 8, -20],
    "s": [21, 1, 6],
    "pe": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [184, 10, -20],
    "s": [2, 1, 1],
    "pe": 1,
    "c": 3421236,
    "t": 5
  }, {
    "p": [184, 11, -20],
    "s": [22, 11, 1],
    "pe": 1,
    "c": 3421236,
    "t": 5
  }, {
    "p": [184, 12, -19],
    "s": [20, 9, 1],
    "pe": 1,
    "c": 3421236,
    "e": 16777215,
    "t": 5
  }, {
    "p": [164, 3, -13],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 9671571,
    "t": 5
  }, {
    "p": [235, 3, 48],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [-3.14, 1.4, -3.14],
    "c": 9671571,
    "t": 5
  }, {
    "p": [143, 2, 84],
    "s": [1, 17, 3],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7692103,
    "t": 5
  }, {
    "p": [143, 2, 80],
    "s": [1, 17, 3],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7692103,
    "t": 5
  }, {
    "p": [225, 3, 68],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 9671571,
    "t": 5
  }, {
    "p": [258, 30, -100],
    "s": [8, 1, 1],
    "l": 1,
    "c": 9012870,
    "t": 5
  }, {
    "p": [261, 28, -100],
    "s": [5, 2, 3],
    "l": 1,
    "c": 9012870,
    "t": 5
  }, {
    "p": [261, 27, -100],
    "s": [4, 1, 2],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [-152, 27, 148],
    "s": [5, 2, 3],
    "l": 1,
    "c": 9012870,
    "t": 5
  }, {
    "p": [-150, 29, 148],
    "s": [6, 1, 1],
    "l": 1,
    "c": 9012870,
    "t": 5
  }, {
    "p": [-152, 26, 148],
    "s": [4, 1, 2],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [-242, 26, 73],
    "s": [4, 1, 1],
    "l": 1,
    "c": 9012870,
    "t": 5
  }, {
    "p": [-240, 24, 73],
    "s": [4, 2, 3],
    "l": 1,
    "c": 9012870,
    "t": 5
  }, {
    "p": [-240, 23, 73],
    "s": [3, 1, 2],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [-234, 22, -128],
    "s": [1, 1, 4],
    "l": 1,
    "c": 9012870,
    "t": 5
  }, {
    "p": [-234, 20, -126],
    "s": [3, 2, 4],
    "l": 1,
    "c": 9012870,
    "t": 5
  }, {
    "p": [-234, 19, -126],
    "s": [2, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [306, 65, 63],
    "s": [8, 1, 1],
    "l": 1,
    "c": 9012870,
    "t": 5
  }, {
    "p": [309, 63, 63],
    "s": [5, 2, 3],
    "l": 1,
    "c": 9012870,
    "t": 5
  }, {
    "p": [309, 62, 63],
    "s": [4, 1, 2],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [198, 0, 242],
    "s": [123, 42, 120],
    "c": 5799880,
    "t": 5,
    "bo": 1
  }, {
    "p": [198, 42, 242],
    "s": [130, 2, 128],
    "c": 8553090,
    "t": 5,
    "bo": 1
  }, {
    "p": [167, 0, 311],
    "s": [30, 61, 18],
    "c": 7368816,
    "t": 5,
    "bo": 1
  }, {
    "p": [303, 6, 186],
    "s": [23, 27, 23],
    "l": 1,
    "c": 4743462,
    "t": 5
  }, {
    "p": [331, 10, 205],
    "s": [31, 30, 30],
    "l": 1,
    "c": 7576379,
    "t": 5
  }, {
    "p": [-121, 0, 322],
    "s": [123, 60, 120],
    "c": 12951902,
    "t": 5,
    "bo": 1
  }, {
    "p": [-121, 60, 322],
    "s": [130, 2, 126],
    "c": 6908265,
    "t": 5,
    "bo": 1
  }, {
    "p": [-58, 35, 356],
    "s": [3, 1, 14],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-58, 36, 356],
    "s": [1, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-59, 36, 362],
    "s": [2, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-59, 36, 350],
    "s": [2, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-59, 48, 356],
    "s": [3, 1, 14],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-59, 36, 356],
    "s": [1, 12, 11],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [-112, 35, 261],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-112, 36, 262],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-106, 36, 262],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-118, 36, 262],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-112, 48, 262],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-112, 36, 262],
    "s": [11, 12, 1],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [77, 49, -131],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [77, 50, -132],
    "s": [11, 12, 1],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [71, 50, -132],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [83, 50, -132],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [77, 62, -132],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [77, 50, -132],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [95, 47, -163],
    "s": [3, 1, 14],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [94, 48, -163],
    "s": [1, 12, 11],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [93, 48, -157],
    "s": [4, 13, 1],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [94, 60, -163],
    "s": [3, 1, 14],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [93, 48, -169],
    "s": [4, 13, 1],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [93, 48, -163],
    "s": [4, 13, 1],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [32, 0, -109],
    "s": [23, 2, 6],
    "c": 7368816,
    "t": 5
  }, {
    "p": [113, -1, 298],
    "s": [4, 28, 4],
    "c": 6574655,
    "t": 5
  }, {
    "p": [114, 22, 298],
    "s": [26, 28, 28],
    "c": 5204775,
    "t": 5,
    "bo": 1
  }, {
    "p": [-121, 0, 322],
    "s": [135, 8, 133],
    "c": 6193707,
    "t": 5
  }, {
    "p": [124, 11, -198],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5
  }, {
    "p": [418, 15, -183],
    "s": [26, 33, 28],
    "l": 1,
    "c": 7247414,
    "t": 5
  }, {
    "p": [163, 2, 422],
    "s": [113, 78, 116],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [165, 0, 419],
    "s": [134, 8, 126],
    "c": 6193707,
    "t": 5
  }, {
    "p": [85, 0, 498],
    "s": [2, 73, 2],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [79, 71, 498],
    "s": [10, 2, 2],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [75, 70, 188],
    "s": [10, 2, 4],
    "c": 7368816,
    "t": 5
  }, {
    "p": [75, 69, 498],
    "s": [9, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [163, 80, 422],
    "s": [123, 3, 125],
    "l": 1,
    "c": 5921370,
    "t": 5,
    "bo": 1
  }, {
    "p": [106, 54, 387],
    "s": [1, 12, 11],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [105, 53, 387],
    "s": [3, 1, 14],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [105, 66, 387],
    "s": [3, 1, 14],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [106, 54, 393],
    "s": [2, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [106, 54, 381],
    "s": [2, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [106, 54, 387],
    "s": [2, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [106, 54, 452],
    "s": [1, 12, 11],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [105, 53, 452],
    "s": [3, 1, 14],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [105, 66, 452],
    "s": [3, 1, 14],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [106, 54, 446],
    "s": [2, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [106, 54, 458],
    "s": [2, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [106, 54, 452],
    "s": [2, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [253, -1, 376],
    "s": [4, 28, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [253, 22, 376],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5
  }, {
    "p": [-224, 19, 248],
    "s": [26, 28, 28],
    "l": 1,
    "c": 7709238,
    "t": 5
  }, {
    "p": [-224, -1, 248],
    "s": [4, 23, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-89, 0, 470],
    "s": [104, 135, 116],
    "c": 10658466,
    "t": 5
  }, {
    "p": [-30, -1, 392],
    "s": [4, 31, 4],
    "c": 6574655,
    "t": 5
  }, {
    "p": [-30, 23, 392],
    "s": [27, 28, 24],
    "c": 6193707,
    "t": 5
  }, {
    "p": [-89, 135, 470],
    "s": [110, 3, 122],
    "l": 1,
    "c": 5921370,
    "t": 5
  }, {
    "p": [-89, 65, 470],
    "s": [111, 5, 124],
    "c": 5921370,
    "t": 5
  }, {
    "p": [-27, 0, 651],
    "s": [2, 73, 2],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [-21, 71, 651],
    "s": [10, 2, 2],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [-17, 70, 651],
    "s": [10, 2, 4],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [-17, 69, 651],
    "s": [9, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [107, -1, 504],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [107, 21, 504],
    "s": [27, 28, 24],
    "l": 1,
    "c": 6193707,
    "t": 5
  }, {
    "p": [156, 0, 621],
    "s": [123, 84, 120],
    "l": 1,
    "c": 12951902,
    "t": 5
  }, {
    "p": [-97, 0, 686],
    "s": [123, 52, 120],
    "l": 1,
    "c": 5799880,
    "t": 5
  }, {
    "p": [-97, 52, 686],
    "s": [131, 4, 132],
    "l": 1,
    "c": 5723991,
    "t": 5
  }, {
    "p": [156, 84, 621],
    "s": [131, 5, 132],
    "l": 1,
    "c": 5723991,
    "t": 5
  }, {
    "p": [489, 22, 19],
    "s": [26, 28, 28],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [427, 18, 111],
    "s": [26, 28, 28],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [446, 15, 26],
    "s": [27, 30, 30],
    "l": 1,
    "c": 7576379,
    "t": 5
  }, {
    "p": [387, 13, 187],
    "s": [23, 27, 23],
    "l": 1,
    "c": 4743462,
    "t": 5
  }, {
    "p": [458, 18, 69],
    "s": [23, 24, 27],
    "l": 1,
    "c": 4743462,
    "t": 5
  }, {
    "p": [727, 0, -41],
    "s": [104, 74, 79],
    "l": 1,
    "c": 10658466,
    "t": 5
  }, {
    "p": [687, 74, -41],
    "s": [24, 48, 26],
    "l": 1,
    "c": 10658466,
    "t": 5
  }, {
    "p": [727, 74, -41],
    "s": [105, 6, 76],
    "l": 1,
    "c": 10658466,
    "t": 5
  }, {
    "p": [687, 121, -41],
    "s": [31, 6, 32],
    "l": 1,
    "c": 7890002,
    "t": 5
  }, {
    "p": [687, 127, -41],
    "s": [22, 13, 19],
    "l": 1,
    "c": 7890002,
    "t": 5
  }, {
    "p": [727, 80, -41],
    "s": [105, 6, 54],
    "l": 1,
    "c": 10658466,
    "t": 5
  }, {
    "p": [727, 84, -61],
    "s": [115, 6, 53],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": 7890002,
    "t": 5
  }, {
    "p": [681, 154, -41],
    "s": [2, 25, 2],
    "l": 1,
    "c": 7890002,
    "t": 5
  }, {
    "p": [681, 171, -41],
    "s": [2, 2, 14],
    "l": 1,
    "c": 7890002,
    "t": 5
  }, {
    "p": [687, 124, -30],
    "s": [22, 33, 11],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 7890002,
    "t": 5
  }, {
    "p": [687, 124, -52],
    "s": [22, 33, 11],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 7890002,
    "t": 5
  }, {
    "p": [727, 84, -22],
    "s": [115, 6, 51],
    "l": 1,
    "r": [0.53, 0, 0],
    "c": 7890002,
    "t": 5
  }, {
    "p": [727, 80, -41],
    "s": [105, 12, 34],
    "l": 1,
    "c": 10658466,
    "t": 5
  }, {
    "p": [674, 0, -41],
    "s": [2, 57, 32],
    "l": 1,
    "c": 7890002,
    "t": 5
  }, {
    "p": [692, 16, -106],
    "s": [26, 31, 28],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [691, -1, -106],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [648, 17, 8],
    "s": [26, 34, 28],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [648, -1, 9],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [458, 17, -140],
    "s": [26, 31, 28],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [621, 18, -154],
    "s": [26, 28, 28],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [621, -1, -154],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [208, 0, -376],
    "s": [121, 69, 83],
    "l": 1,
    "c": 10658466,
    "t": 5
  }, {
    "p": [674, 108, -41],
    "s": [1, 9, 9],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [673, 113, -41],
    "s": [1, 4, 1],
    "l": 1,
    "c": 2960685,
    "t": 5
  }, {
    "p": [673, 113, -41],
    "s": [1, 4, 1],
    "l": 1,
    "r": [2.09, 0, 0],
    "c": 2960685,
    "t": 5
  }, {
    "p": [674, 64, -41],
    "s": [2, 19, 4],
    "l": 1,
    "c": 2105376,
    "t": 5
  }, {
    "p": [752, 18, 167],
    "s": [39, 24, 1182],
    "l": 1,
    "c": 4743462,
    "t": 5
  }, {
    "p": [611, 18, -401],
    "s": [257, 31, 27],
    "l": 1,
    "c": 6060596,
    "t": 5
  }, {
    "p": [592, 31, -395],
    "s": [38, 34, 28],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [737, 15, -383],
    "s": [47, 36, 49],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [746, 22, -200],
    "s": [38, 28, 38],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [746, 22, -292],
    "s": [38, 33, 38],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [748, 0, -142],
    "s": [4, 23, 132],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [758, 0, -298],
    "s": [4, 23, 219],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [735, -1, -287],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [27, 0, 172],
    "s": [1506, 0, 1212],
    "i": 4,
    "c": "#728447",
    "t": 5
  }, {
    "p": [640, 0, -405],
    "s": [307, 23, 5],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [542, -1, -391],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [610, 18, -235],
    "s": [26, 28, 28],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [610, -1, -235],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [460, -1, -324],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [460, 18, -324],
    "s": [26, 28, 28],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [748, 0, 331],
    "s": [4, 23, 852],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [501, 17, -113],
    "s": [26, 28, 28],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [459, 9, -102],
    "s": [25, 26, 25],
    "l": 1,
    "c": 5732402,
    "t": 5
  }, {
    "p": [451, 22, 93],
    "s": [26, 24, 25],
    "l": 1,
    "c": 6984507,
    "t": 5
  }, {
    "p": [439, 10, 60],
    "s": [26, 28, 29],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [424, 15, 135],
    "s": [30, 28, 27],
    "l": 1,
    "c": 4743462,
    "t": 5
  }, {
    "p": [501, 16, -8],
    "s": [29, 25, 29],
    "l": 1,
    "c": 4941357,
    "t": 5
  }, {
    "p": [530, 9, -52],
    "s": [29, 25, 29],
    "l": 1,
    "c": 5732402,
    "t": 5
  }, {
    "p": [595, 9, 107],
    "s": [29, 25, 29],
    "l": 1,
    "c": 5732402,
    "t": 5
  }, {
    "p": [418, 13, 183],
    "s": [29, 25, 29],
    "l": 1,
    "c": 5732402,
    "t": 5
  }, {
    "p": [477, 20, 166],
    "s": [27, 30, 30],
    "l": 1,
    "c": 7576379,
    "t": 5
  }, {
    "p": [746, 22, 77],
    "s": [38, 28, 44],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [746, 22, 140],
    "s": [38, 29, 41],
    "l": 1,
    "c": 6588720,
    "t": 5
  }, {
    "p": [746, 23, 254],
    "s": [38, 28, 34],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [746, 18, 349],
    "s": [38, 29, 74],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [450, 14, -177],
    "s": [25, 30, 25],
    "l": 1,
    "c": 5732402,
    "t": 5
  }, {
    "p": [166, 0, -429],
    "s": [1786, 23, 5],
    "l": 1,
    "c": 5917499,
    "t": 5
  }, {
    "p": [-81, 19, -418],
    "s": [1233, 31, 27],
    "l": 1,
    "c": 6060596,
    "t": 5
  }, {
    "p": [436, 16, -407],
    "s": [38, 37, 28],
    "l": 1,
    "c": 5665581,
    "t": 5
  }, {
    "p": [319, 17, -407],
    "s": [38, 37, 28],
    "l": 1,
    "c": 5665581,
    "t": 5
  }, {
    "p": [437, -1, -401],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [318, -1, -401],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [291, -1, -412],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [371, -1, -412],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [376, 31, -439],
    "s": [38, 33, 28],
    "l": 1,
    "c": 5665581,
    "t": 5
  }, {
    "p": [291, -1, -234],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [291, 8, -237],
    "s": [31, 33, 28],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [208, 69, -376],
    "s": [128, 3, 89],
    "l": 1,
    "c": 6381921,
    "t": 5
  }, {
    "p": [399, -1, 45],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [408, -1, -415],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [242, 47, -334],
    "s": [11, 12, 1],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [173, 47, -334],
    "s": [11, 12, 1],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [173, 46, -333],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [173, 59, -333],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [242, 59, -333],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [242, 46, -333],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [167, 47, -334],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [179, 47, -334],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [236, 47, -334],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [248, 47, -334],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [242, 47, -334],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [173, 47, -334],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-24, 112, 468],
    "s": [2, 9, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5
  }, {
    "p": [-27, 66, 470],
    "s": [14, 57, 3],
    "l": 1,
    "c": 5921370,
    "t": 5
  }, {
    "p": [-30, 112, 468],
    "s": [2, 9, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5
  }, {
    "p": [-27, 116, 468],
    "s": [4, 2, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5
  }, {
    "p": [-24, 101, 468],
    "s": [2, 9, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5
  }, {
    "p": [-30, 101, 468],
    "s": [2, 9, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5
  }, {
    "p": [-27, 101, 468],
    "s": [4, 2, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5
  }, {
    "p": [-27, 108, 468],
    "s": [4, 2, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5
  }, {
    "p": [-27, 90, 468],
    "s": [2, 9, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5
  }, {
    "p": [-27, 97, 468],
    "s": [8, 2, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5
  }, {
    "p": [-25, 79, 468],
    "s": [2, 9, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5
  }, {
    "p": [-27, 86, 468],
    "s": [6, 2, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5
  }, {
    "p": [-27, 79, 468],
    "s": [6, 2, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5
  }, {
    "p": [-27, 82, 468],
    "s": [6, 2, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5
  }, {
    "p": [-25, 68, 468],
    "s": [2, 9, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5
  }, {
    "p": [-28, 68, 468],
    "s": [6, 2, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5
  }, {
    "p": [-37, 108, 470],
    "s": [6, 3, 3],
    "l": 1,
    "c": 5921370,
    "t": 5
  }, {
    "p": [-37, 77, 470],
    "s": [6, 3, 3],
    "l": 1,
    "c": 5921370,
    "t": 5
  }, {
    "p": [65, 1, 654],
    "s": [51, 15, 20],
    "i": 7,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [32, 0, 814],
    "s": [79, 135, 116],
    "l": 1,
    "c": 10658466,
    "t": 5
  }, {
    "p": [32, 135, 814],
    "s": [87, 3, 124],
    "l": 1,
    "c": 6052956,
    "t": 5
  }, {
    "p": [88, -1, 709],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [90, 17, 708],
    "s": [27, 28, 24],
    "l": 1,
    "c": 6193707,
    "t": 5
  }, {
    "p": [-33, -1, 770],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-34, 16, 770],
    "s": [27, 28, 24],
    "l": 1,
    "c": 6193707,
    "t": 5
  }, {
    "p": [115, -2, 958],
    "s": [113, 65, 116],
    "l": 1,
    "c": 12927811,
    "t": 5
  }, {
    "p": [115, 63, 958],
    "s": [124, 5, 126],
    "l": 1,
    "c": 5066061,
    "t": 5
  }, {
    "p": [-63, -18, 928],
    "s": [123, 112, 120],
    "l": 1,
    "c": 12951902,
    "t": 5
  }, {
    "p": [-63, 93, 928],
    "s": [131, 4, 127],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [-155, -75, 1251],
    "s": [79, 289, 61],
    "l": 1,
    "c": 10658466,
    "t": 5
  }, {
    "p": [151, -31, 1120],
    "s": [108, 142, 61],
    "l": 1,
    "c": 10658466,
    "t": 5
  }, {
    "p": [308, 0, 1120],
    "s": [79, 220, 61],
    "l": 1,
    "c": 10658466,
    "t": 5
  }, {
    "p": [-269, -31, 1008],
    "s": [108, 142, 113],
    "l": 1,
    "c": 10658466,
    "t": 5
  }, {
    "p": [437, 0, 747],
    "s": [677, 23, 5],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [609, 21, 751],
    "s": [315, 24, 44],
    "l": 1,
    "c": 4743462,
    "t": 5
  }, {
    "p": [269, 21, 751],
    "s": [374, 27, 53],
    "l": 1,
    "c": 4743462,
    "t": 5
  }, {
    "p": [525, 20, 744],
    "s": [38, 29, 41],
    "l": 1,
    "c": 6588720,
    "t": 5
  }, {
    "p": [744, 18, 739],
    "s": [43, 35, 46],
    "l": 1,
    "c": 6588720,
    "t": 5
  }, {
    "p": [333, 22, 743],
    "s": [38, 32, 41],
    "l": 1,
    "c": 6588720,
    "t": 5
  }, {
    "p": [636, 20, 744],
    "s": [38, 29, 41],
    "l": 1,
    "c": 6588720,
    "t": 5
  }, {
    "p": [746, 23, 557],
    "s": [38, 28, 34],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [443, 24, 258],
    "s": [23, 24, 23],
    "l": 1,
    "c": 4743462,
    "t": 5
  }, {
    "p": [359, 11, 197],
    "s": [24, 24, 30],
    "l": 1,
    "c": 6390324,
    "t": 5
  }, {
    "p": [313, 13, 245],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5
  }, {
    "p": [369, 60, 323],
    "s": [132, 3, 130],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [369, -4, 323],
    "s": [123, 64, 120],
    "l": 1,
    "c": 12951902,
    "t": 5
  }, {
    "p": [252, 12, -209],
    "s": [26, 28, 28],
    "l": 1,
    "c": 4940075,
    "t": 5
  }, {
    "p": [208, -1, -370],
    "s": [137, 10, 89],
    "c": 6984507,
    "t": 5
  }, {
    "p": [373, 18, -259],
    "s": [26, 28, 28],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [247, 24, 743],
    "s": [38, 32, 41],
    "l": 1,
    "c": 6588720,
    "t": 5
  }, {
    "p": [571, -57, 1262],
    "s": [79, 220, 61],
    "l": 1,
    "c": 10658466,
    "t": 5
  }, {
    "p": [563, 13, 53],
    "s": [29, 25, 29],
    "l": 1,
    "c": 5732402,
    "t": 5
  }, {
    "p": [439, 5, 10],
    "s": [29, 25, 29],
    "l": 1,
    "c": 5732402,
    "t": 5
  }, {
    "p": [288, 9, -185],
    "s": [25, 26, 25],
    "l": 1,
    "c": 5732402,
    "t": 5
  }, {
    "p": [337, 14, -183],
    "s": [25, 26, 25],
    "l": 1,
    "c": 6720572,
    "t": 5
  }, {
    "p": [164, 6, -221],
    "s": [25, 30, 25],
    "l": 1,
    "c": 5732402,
    "t": 5
  }, {
    "p": [213, 12, -250],
    "s": [21, 25, 21],
    "l": 1,
    "c": 5732402,
    "t": 5
  }, {
    "p": [368, 15, -183],
    "s": [26, 27, 28],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [392, 11, -194],
    "s": [25, 26, 25],
    "l": 1,
    "c": 5666099,
    "t": 5
  }, {
    "p": [316, 5, -203],
    "s": [25, 26, 25],
    "l": 1,
    "c": 5666099,
    "t": 5
  }, {
    "p": [439, 8, 83],
    "s": [29, 25, 29],
    "l": 1,
    "c": 5732402,
    "t": 5
  }, {
    "p": [212, 18, -319],
    "s": [26, 28, 28],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [51, 31, -439],
    "s": [38, 33, 28],
    "l": 1,
    "c": 5665581,
    "t": 5
  }, {
    "p": [111, 17, -407],
    "s": [38, 37, 28],
    "l": 1,
    "c": 5665581,
    "t": 5
  }, {
    "p": [25, -1, -412],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [111, -1, -401],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [73, -1, -407],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-92, 17, -407],
    "s": [38, 37, 28],
    "l": 1,
    "c": 5665581,
    "t": 5
  }, {
    "p": [-175, 27, -427],
    "s": [38, 33, 28],
    "l": 1,
    "c": 5665581,
    "t": 5
  }, {
    "p": [-175, 27, -427],
    "s": [38, 33, 28],
    "l": 1,
    "c": 5665581,
    "t": 5
  }, {
    "p": [-90, -1, -400],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-174, -1, -418],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-67, 22, -274],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5
  }, {
    "p": [-66, -1, -273],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-12, 50, -132],
    "s": [11, 12, 1],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [-12, 49, -131],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-12, 62, -132],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-18, 50, -132],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-6, 50, -132],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-12, 50, -132],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-63, 10, -181],
    "s": [25, 30, 25],
    "l": 1,
    "c": 6851648,
    "t": 5
  }, {
    "p": [32, 26, -126],
    "s": [16, 13, 22],
    "c": 12958048,
    "t": 5,
    "bo": 1
  }, {
    "p": [125, -1, 2],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [128, 0, 89],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [88, -1, 82],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [142, -1, 128],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [-37, -1, -55],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [239, 3, -66],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 9671571,
    "t": 5
  }, {
    "p": [-38, 3, 157],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 9671571,
    "t": 5
  }, {
    "p": [-247, -1, -414],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-341, -1, -413],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-252, 15, -427],
    "s": [51, 58, 28],
    "l": 1,
    "c": 5665581,
    "t": 5
  }, {
    "p": [-372, 15, -411],
    "s": [48, 41, 35],
    "l": 1,
    "c": 5665581,
    "t": 5
  }, {
    "p": [-212, 10, -177],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5
  }, {
    "p": [-156, -1, 235],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-157, 15, 235],
    "s": [26, 28, 28],
    "l": 1,
    "c": 7709238,
    "t": 5
  }, {
    "p": [165, -1, -213],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [203, -1, -186],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [124, -1, -188],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [285, -1, -185],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [250, -1, -202],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-125, -1, -105],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [-262, -1, -17],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [-245, -1, 190],
    "s": [4, 2, 6],
    "c": 7368816,
    "t": 5
  }, {
    "p": [392, -1, 40],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [265, -1, -65],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [109, -1, -146],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [213, -1, -318],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [213, -1, -248],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [55, -1, -407],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [24, 1, 395],
    "s": [51, 15, 20],
    "i": 7,
    "l": 1,
    "r": [3.14, -1.22, 3.14]
  }, {
    "p": [-259, 17, 231],
    "s": [26, 28, 28],
    "l": 1,
    "c": 7709238,
    "t": 5
  }, {
    "p": [-203, 18, 291],
    "s": [26, 26, 28],
    "l": 1,
    "c": 6193707,
    "t": 5
  }, {
    "p": [-203, -1, 292],
    "s": [4, 23, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-155, -75, 1251],
    "s": [4, 341, 4],
    "l": 1,
    "c": 10658466,
    "t": 5
  }, {
    "p": [308, 85, 1120],
    "s": [4, 189, 2],
    "l": 1,
    "c": 10658466,
    "t": 5
  }, {
    "p": [-102, -1, -180],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-64, -1, -180],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-285, -1, -78],
    "s": [4, 2, 4],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [-39, -1, -141],
    "s": [4, 2, 4],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [350, -1, 5],
    "s": [4, 2, 4],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [427, -1, -136],
    "s": [4, 2, 4],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [327, -1, 154],
    "s": [4, 2, 4],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [200, -1, 121],
    "s": [4, 2, 4],
    "c": 7368816,
    "t": 5
  }, {
    "p": [-11, 0, -75],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [133, 0, 15],
    "s": [1, 15, 3],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": 7692103,
    "t": 5
  }, {
    "p": [133, 0, 11],
    "s": [1, 15, 3],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": 7692103,
    "t": 5
  }, {
    "p": [-47, 2, 22],
    "s": [4, 36, 76],
    "c": 5799880,
    "t": 5
  }, {
    "p": [-253, 16, -176],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5
  }, {
    "p": [-182, 0, -245],
    "s": [121, 51, 83],
    "c": 13619151,
    "t": 5
  }, {
    "p": [-209, -1, -176],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-183, 66, -58],
    "s": [4, 1, 1],
    "l": 1,
    "c": 9012870,
    "t": 5
  }, {
    "p": [-185, 64, -58],
    "s": [4, 2, 3],
    "l": 1,
    "c": 9012870,
    "t": 5
  }, {
    "p": [-185, 63, -58],
    "s": [3, 1, 2],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [-182, 51, -245],
    "s": [130, 3, 95],
    "c": 7039851,
    "t": 5
  }, {
    "p": [-173, 31, -203],
    "s": [11, 12, 1],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [-179, 31, -203],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-167, 31, -203],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-173, 31, -203],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-173, 30, -203],
    "s": [14, 1, 4],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-173, 43, -203],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-392, 0, 747],
    "s": [677, 23, 5],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-385, 21, 751],
    "s": [691, 27, 53],
    "l": 1,
    "c": 4743462,
    "t": 5
  }, {
    "p": [-405, 0, -51],
    "s": [123, 60, 120],
    "c": 12951902,
    "t": 5
  }, {
    "p": [-403, 60, -51],
    "s": [130, 2, 130],
    "c": 5263440,
    "t": 5
  }, {
    "p": [-316, 15, 11],
    "s": [26, 30, 28],
    "l": 1,
    "c": 7709238,
    "t": 5
  }, {
    "p": [-320, -1, 173],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-707, 19, 165],
    "s": [44, 31, 1300],
    "l": 1,
    "c": 6060596,
    "t": 5
  }, {
    "p": [-694, 0, 183],
    "s": [1, 23, 1208],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-343, 40, -83],
    "s": [1, 12, 11],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [-344, 52, -83],
    "s": [4, 1, 13],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-343, 39, -83],
    "s": [4, 1, 14],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-344, 40, -89],
    "s": [4, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-344, 40, -77],
    "s": [4, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-344, 40, -83],
    "s": [4, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-315, 5, -45],
    "s": [26, 30, 28],
    "l": 1,
    "c": 6786608,
    "t": 5
  }, {
    "p": [-371, -25, 16],
    "s": [27, 105, 15],
    "c": 6579300,
    "t": 5
  }, {
    "p": [-310, 16, -166],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5
  }, {
    "p": [-310, -1, -167],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-290, 11, -213],
    "s": [26, 30, 28],
    "l": 1,
    "c": 7709238,
    "t": 5
  }, {
    "p": [-270, 16, -274],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5
  }, {
    "p": [-269, -1, -271],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-334, 16, -216],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5
  }, {
    "p": [-328, -1, -219],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-42, 0, 25],
    "s": [6, 9, 78],
    "c": 6984507,
    "t": 5
  }, {
    "p": [17, 2, -126],
    "s": [14, 37, 22],
    "c": 12958048,
    "t": 5,
    "bo": 1
  }, {
    "p": [32, 2, -119],
    "s": [16, 24, 2],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "bo": 1
  }, {
    "p": [47, 2, -126],
    "s": [14, 37, 22],
    "c": 12958048,
    "t": 5,
    "bo": 1
  }, {
    "p": [-255, -1, 230],
    "s": [4, 23, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [275, -1, 183],
    "s": [4, 28, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [32, 42, -132],
    "s": [29, 18, 1],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [17, 42, -132],
    "s": [1, 18, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [32, 42, -132],
    "s": [1, 18, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [32, 60, -132],
    "s": [31, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [11, 42, -116],
    "s": [2, 8, 2],
    "l": 1,
    "c": 5263440,
    "t": 5
  }, {
    "p": [53, 42, -116],
    "s": [2, 8, 2],
    "l": 1,
    "c": 5263440,
    "t": 5
  }, {
    "p": [53, 42, -131],
    "s": [2, 8, 2],
    "l": 1,
    "c": 5263440,
    "t": 5
  }, {
    "p": [11, 42, -131],
    "s": [2, 8, 2],
    "l": 1,
    "c": 5263440,
    "t": 5
  }, {
    "p": [11, 42, -123],
    "s": [1, 7, 1],
    "l": 1,
    "c": 5263440,
    "t": 5
  }, {
    "p": [53, 42, -124],
    "s": [1, 7, 1],
    "l": 1,
    "c": 5263440,
    "t": 5
  }, {
    "p": [46, 42, -116],
    "s": [1, 7, 1],
    "l": 1,
    "c": 5263440,
    "t": 5
  }, {
    "p": [18, 42, -116],
    "s": [1, 7, 1],
    "l": 1,
    "c": 5263440,
    "t": 5
  }, {
    "p": [27, 42, -116],
    "s": [1, 7, 1],
    "l": 1,
    "c": 5263440,
    "t": 5
  }, {
    "p": [36, 42, -116],
    "s": [1, 7, 1],
    "l": 1,
    "c": 5263440,
    "t": 5
  }, {
    "p": [32, 49, -116],
    "s": [42, 1, 2],
    "l": 1,
    "c": 5263440,
    "t": 5
  }, {
    "p": [53, 49, -124],
    "s": [2, 1, 14],
    "l": 1,
    "c": 5263440,
    "t": 5
  }, {
    "p": [11, 49, -123],
    "s": [2, 1, 14],
    "l": 1,
    "c": 5263440,
    "t": 5
  }, {
    "p": [-183, 36, -58],
    "s": [4, 2, 20],
    "c": 7368816,
    "t": 5
  }, {
    "p": [306, 36, 64],
    "s": [4, 2, 20],
    "c": 7368816,
    "t": 5
  }, {
    "p": [47, 42, -132],
    "s": [1, 18, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [340, -1, -182],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [369, -1, -182],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [419, -1, -183],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [391, -1, -193],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-70, 2, 160],
    "s": [3, 6, 6],
    "l": 1,
    "c": 12927811,
    "t": 5
  }, {
    "p": [-70, 7, 162],
    "s": [1, 3, 1],
    "l": 1,
    "c": 8882055,
    "t": 5
  }, {
    "p": [98, 2, -212],
    "s": [14, 100, 25],
    "c": 7368816,
    "t": 11
  }, {
    "p": [-397, 16, -128],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5
  }, {
    "p": [-389, -1, -128],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-689, 15, -307],
    "s": [48, 41, 58],
    "l": 1,
    "c": 5665581,
    "t": 5
  }, {
    "p": [-689, 17, -208],
    "s": [48, 41, 41],
    "l": 1,
    "c": 5665581,
    "t": 5
  }, {
    "p": [-574, 17, -413],
    "s": [48, 41, 35],
    "l": 1,
    "c": 5665581,
    "t": 5
  }, {
    "p": [-404, 17, -176],
    "s": [26, 31, 28],
    "l": 1,
    "c": 5204775,
    "t": 5
  }, {
    "p": [-405, -1, -177],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-460, 15, -411],
    "s": [36, 43, 35],
    "l": 1,
    "c": 5665581,
    "t": 5
  }, {
    "p": [369, 39, 263],
    "s": [11, 12, 1],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [369, 38, 262],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [369, 51, 263],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [375, 39, 263],
    "s": [1, 12, 3],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [363, 39, 263],
    "s": [1, 12, 3],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [369, 39, 263],
    "s": [1, 12, 3],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-372, 0, 98],
    "s": [104, 106, 116],
    "l": 1,
    "c": 10658466,
    "t": 5
  }, {
    "p": [-372, 105, 98],
    "s": [115, 3, 126],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [-366, 17, 737],
    "s": [48, 41, 41],
    "l": 1,
    "c": 5665581,
    "t": 5
  }, {
    "p": [-489, 17, 737],
    "s": [66, 36, 41],
    "l": 1,
    "c": 5665581,
    "t": 5
  }, {
    "p": [-205, 17, 737],
    "s": [66, 36, 41],
    "l": 1,
    "c": 5665581,
    "t": 5
  }, {
    "p": [-624, 17, 737],
    "s": [66, 39, 41],
    "l": 1,
    "c": 5665581,
    "t": 5
  }, {
    "p": [-689, 17, 202],
    "s": [48, 41, 41],
    "l": 1,
    "c": 5665581,
    "t": 5
  }, {
    "p": [-689, 17, 318],
    "s": [48, 41, 41],
    "l": 1,
    "c": 5665581,
    "t": 5
  }, {
    "p": [-306, 23, 205],
    "s": [26, 26, 28],
    "l": 1,
    "c": 6193707,
    "t": 5
  }, {
    "p": [-306, -1, 205],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [-290, 12, 243],
    "s": [26, 28, 28],
    "l": 1,
    "c": 8695624,
    "t": 5
  }, {
    "p": [-288, -1, 249],
    "s": [4, 23, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [126, 0, 60],
    "s": [2, 37, 2],
    "pe": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [126, 0, 98],
    "s": [2, 37, 2],
    "pe": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [-161, -1, 205],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [-290, -1, -49],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [238, -1, -156],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [182, -1, 159],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [296, -1, 159],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [1009, 10, 134],
    "s": [65, 76, 76],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [995, 21, -386],
    "s": [65, 53, 76],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [555, 21, -559],
    "s": [137, 54, 76],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [924, 10, 606],
    "s": [74, 74, 87],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [-289, -7, 309],
    "s": [82, 106, 86],
    "l": 1,
    "c": 10658466,
    "t": 5
  }, {
    "p": [849, -8, -520],
    "s": [65, 84, 76],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [661, -4, 165],
    "s": [123, 64, 120],
    "l": 1,
    "c": 12951902,
    "t": 5
  }, {
    "p": [661, 60, 165],
    "s": [132, 4, 131],
    "l": 1,
    "c": 6381921,
    "t": 5
  }, {
    "p": [-289, 99, 309],
    "s": [89, 4, 93],
    "l": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [-345, 18, 247],
    "s": [26, 26, 28],
    "l": 1,
    "c": 6193707,
    "t": 5
  }, {
    "p": [-431, 14, 166],
    "s": [26, 26, 28],
    "l": 1,
    "c": 6193707,
    "t": 5
  }, {
    "p": [-269, 74, 266],
    "s": [11, 12, 1],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [-269, 73, 265],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-269, 86, 266],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-263, 74, 266],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-275, 74, 266],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [-269, 74, 266],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5
  }, {
    "p": [995, 17, -153],
    "s": [65, 68, 47],
    "l": 1,
    "c": 6324784,
    "t": 5
  }, {
    "p": [-136, 3, -80],
    "s": [7, 32, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [-130, 3, -80],
    "s": [7, 29, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [-124, 3, -80],
    "s": [7, 26, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [-118, 3, -80],
    "s": [7, 23, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [-112, 3, -80],
    "s": [7, 20, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [-106, 3, -80],
    "s": [7, 17, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [-100, 3, -80],
    "s": [7, 14, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [-94, 3, -80],
    "s": [7, 11, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [-88, 3, -80],
    "s": [7, 8, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [-82, 3, -80],
    "s": [7, 5, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [-76, 2, -80],
    "s": [7, 3, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [-102, 2, -80],
    "s": [72, 36, 24],
    "i": 9,
    "v": 1,
    "t": 5,
    "d": 2
  }, {
    "p": [-125, 3, 54],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, 1.04, 0],
    "c": 11184810,
    "t": 5
  }, {
    "p": [251, 3, 98],
    "s": [7, 32, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [244, 3, 98],
    "s": [7, 29, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [237, 3, 98],
    "s": [7, 26, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [230, 3, 98],
    "s": [7, 23, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [223, 3, 98],
    "s": [7, 20, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [216, 3, 98],
    "s": [7, 17, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [209, 3, 98],
    "s": [7, 14, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [202, 3, 98],
    "s": [7, 11, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [195, 3, 98],
    "s": [7, 8, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [188, 3, 98],
    "s": [7, 5, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [181, 2, 98],
    "s": [7, 3, 23],
    "c": 8355711,
    "t": 5
  }, {
    "p": [212, 2, 98],
    "s": [84, 36, 24],
    "i": 9,
    "v": 1,
    "t": 5
  }, {
    "p": [137, -1, -156],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [119, 0, -15],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-47, -1, 357],
    "s": [38, 24, 2],
    "c": 7692103,
    "t": 10,
    "bo": 1
  }, {
    "p": [116, -1, 275],
    "s": [41, 24, 2],
    "pe": 1,
    "c": 7692103,
    "t": 10,
    "bo": 1
  }, {
    "p": [70, 2, 357],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -1.23, 0],
    "c": 10329501,
    "t": 5
  }, {
    "p": [-12, 2, 249],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 10329501,
    "t": 5
  }, {
    "p": [-49, -1, 265],
    "s": [21, 24, 2],
    "c": 7692103,
    "t": 10,
    "bo": 1
  }, {
    "p": [-29, -1, 357],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [41, -1, 365],
    "s": [3, 12, 1],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 13158600,
    "t": 5
  }, {
    "p": [58, 9, 369],
    "s": [40, 3, 1],
    "l": 1,
    "c": 13158600,
    "t": 5
  }, {
    "p": [41, -1, 373],
    "s": [3, 12, 1],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 13158600,
    "t": 5
  }, {
    "p": [75, -1, 365],
    "s": [3, 12, 1],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 13158600,
    "t": 5
  }, {
    "p": [75, -1, 373],
    "s": [3, 12, 1],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 13158600,
    "t": 5
  }, {
    "p": [3, 9, 369],
    "s": [40, 3, 1],
    "l": 1,
    "c": 13158600,
    "t": 5
  }, {
    "p": [-14, -1, 365],
    "s": [3, 12, 1],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 13158600,
    "t": 5
  }, {
    "p": [20, -1, 365],
    "s": [3, 12, 1],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 13158600,
    "t": 5
  }, {
    "p": [-14, -1, 373],
    "s": [3, 12, 1],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 13158600,
    "t": 5
  }, {
    "p": [20, -1, 373],
    "s": [3, 12, 1],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 13158600,
    "t": 5
  }, {
    "p": [58, 1, 382],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-31, 0, 369],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-5, 1, 377],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [47, 1, 378],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [34, 1, 368],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [89, 0, 373],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [73, 2, 406],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [3.14, -1.39, 3.14],
    "c": 10329501,
    "t": 5
  }, {
    "p": [75, 2, 282],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -1.4, 0],
    "c": 10329501,
    "t": 5
  }, {
    "p": [90, 0, 266],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [100, -1, 348],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [164, -1, 342],
    "s": [2, 27, 48],
    "pe": 1,
    "c": 7692103,
    "t": 10,
    "bo": 1
  }, {
    "p": [133, 0, 292],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [24, -1, 428],
    "s": [168, 13, 119],
    "v": 1,
    "t": 5,
    "bo": 1
  }, {
    "p": [-47, -1, 363],
    "s": [37, 13, 14],
    "v": 1,
    "t": 5,
    "bo": 1
  }, {
    "p": [-20, 1, 372],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [188, -1, 339],
    "s": [4, 28, 4],
    "l": 1,
    "c": 6574655,
    "t": 5
  }, {
    "p": [189, 22, 341],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5
  }, {
    "p": [221, -1, 351],
    "s": [1, 7, 1],
    "l": 1,
    "c": 6984507,
    "t": 5
  }, {
    "p": [289, -1, 366],
    "s": [1, 7, 1],
    "l": 1,
    "c": 6984507,
    "t": 5
  }, {
    "p": [113, 3, -37],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 9671571,
    "t": 5
  }, {
    "p": [167, 3, -75],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 9671571,
    "t": 5
  }, {
    "p": [164, 39, -13],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 9671571,
    "t": 5
  }, {
    "p": [249, 39, 47],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 9671571,
    "t": 5
  }, {
    "p": [-142, 2, 25],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-175, 2, -28],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [-175, 4, -28],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [243, 2, 8],
    "s": [1, 17, 3],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7692103,
    "t": 5
  }, {
    "p": [-129, 2, 12],
    "s": [1, 17, 3],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7692103,
    "t": 5
  }, {
    "p": [-139, 2, 74],
    "s": [1, 17, 3],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7692103,
    "t": 5
  }, {
    "p": [-139, 2, 81],
    "s": [1, 17, 3],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7692103,
    "t": 5
  }, {
    "p": [158, 38, -22],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [158, 40, -22],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [202, 38, 77],
    "s": [4, 22, 2],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 7692103,
    "t": 5
  }, {
    "p": [209, 38, 77],
    "s": [4, 22, 2],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 7692103,
    "t": 5
  }, {
    "p": [145, 2, -22],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [145, 4, -22],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [188, 8, 88],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [188, 10, 88],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [-93, 14, -70],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [-93, 16, -70],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5
  }, {
    "p": [145, 39, 105],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, 1.39, 0],
    "c": 9671571,
    "t": 5
  }, {
    "p": [168, 38, 106],
    "s": [4, 22, 2],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 7692103,
    "t": 5
  }, {
    "p": [35, 1, 304],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [23, 1, 304],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [29, 13, 304],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-92, 32, -2],
    "s": [7, 2, 7],
    "c": 9012870,
    "t": 5
  }, {
    "p": [-92, 34, -2],
    "s": [3, 2, 3],
    "c": 9012870,
    "t": 5
  }, {
    "p": [-92, 31, -2],
    "s": [3, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [-92, 74, -2],
    "s": [3, 2, 3],
    "c": 9012870,
    "t": 5
  }, {
    "p": [-92, 72, -2],
    "s": [7, 2, 7],
    "c": 9012870,
    "t": 5
  }, {
    "p": [-92, 71, -2],
    "s": [3, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [183, 74, 39],
    "s": [3, 2, 3],
    "c": 9012870,
    "t": 5
  }, {
    "p": [183, 72, 39],
    "s": [7, 2, 7],
    "c": 9012870,
    "t": 5
  }, {
    "p": [183, 71, 39],
    "s": [3, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [183, 34, 39],
    "s": [3, 2, 3],
    "c": 9012870,
    "t": 5
  }, {
    "p": [272, 32, 39],
    "s": [7, 2, 7],
    "c": 9012870,
    "t": 5
  }, {
    "p": [183, 31, 39],
    "s": [3, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [272, 34, 39],
    "s": [3, 2, 3],
    "c": 9012870,
    "t": 5
  }, {
    "p": [183, 32, 39],
    "s": [7, 2, 7],
    "c": 9012870,
    "t": 5
  }, {
    "p": [272, 31, 39],
    "s": [3, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [294, 2, 23],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [288, 3, 9],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [-3.14, 1.4, -3.14],
    "c": 9671571,
    "t": 5
  }, {
    "p": [-163, 32, -2],
    "s": [7, 2, 7],
    "c": 9012870,
    "t": 5
  }, {
    "p": [-163, 34, -2],
    "s": [3, 2, 3],
    "c": 9012870,
    "t": 5
  }, {
    "p": [-163, 31, -2],
    "s": [3, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5
  }, {
    "p": [28, 1, 305],
    "s": [72, 50, 63],
    "i": 14,
    "l": 1
  }, {
    "p": [-89, 38, -8],
    "s": [61, 38, 65],
    "i": 14,
    "l": 1
  }, {
    "p": [184, 2, 37],
    "s": [61, 33, 59],
    "i": 14,
    "l": 1
  }, {
    "p": [367, 0, 32],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": 0
  }, {
    "p": [-215, 0, 35],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": "1"
  }, {
    "p": [-100, 14, 70],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-100, 2, 70],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-35, -1, -18],
    "s": [3, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [-35, -1, -28],
    "s": [3, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [-35, -1, -23],
    "s": [4, 2, 5],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [-29, -1, -28],
    "s": [5, 2, 4],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [-29, -1, -18],
    "s": [5, 2, 4],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [-29, -1, -23],
    "s": [3, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [127, -1, 39],
    "s": [4, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [127, -1, 49],
    "s": [4, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [127, -1, 44],
    "s": [4, 2, 5],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [109, -1, 40],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [121, -1, 48],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [115, -1, 44],
    "s": [4, 2, 5],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [103, -1, 44],
    "s": [4, 2, 5],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [121, -1, 40],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [109, -1, 48],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [115, -1, 49],
    "s": [4, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [115, -1, 39],
    "s": [4, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [97, -1, 48],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [97, -1, 40],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [91, -1, 44],
    "s": [4, 2, 5],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [85, -1, 40],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [85, -1, 48],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [103, -1, 49],
    "s": [4, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [91, -1, 49],
    "s": [4, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [91, -1, 39],
    "s": [4, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [103, -1, 39],
    "s": [4, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5
  }, {
    "p": [-251, -1, 141],
    "s": [4, 26, 4],
    "pe": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [-251, -1, 118],
    "s": [4, 26, 4],
    "pe": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [220, 82, 43],
    "s": [178, 4, 152],
    "r": [0.09, 0, 0],
    "c": 5263440,
    "t": 5,
    "bo": 1
  }, {
    "p": [302, 84, -1],
    "s": [4, 3, 46],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [302, 87, -13],
    "s": [4, 3, 22],
    "c": 12927811,
    "t": 5
  }, {
    "p": [302, 38, 91],
    "s": [4, 38, 38],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [302, 76, 91],
    "s": [4, 3, 38],
    "c": 12927811,
    "t": 5
  }, {
    "p": [138, 66, 81],
    "s": [4, 15, 34],
    "c": 12927811,
    "t": 5,
    "bo": 1
  }, {
    "p": [138, 87, -14],
    "s": [4, 1, 4],
    "c": 12927811,
    "t": 5
  }, {
    "p": [56, 1, 115],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [56, 6, 111],
    "s": [1, 3, 1],
    "c": 8882055,
    "t": 5
  }, {
    "p": [56, 1, 109],
    "s": [3, 6, 6],
    "c": 12927811,
    "t": 5
  }, {
    "p": [40, 10, 48],
    "s": [24, 2, 100],
    "pe": 1,
    "c": 2899797,
    "t": 5
  }, {
    "p": [40, 37, 48],
    "s": [28, 2, 100],
    "pe": 1,
    "c": "#2c3f55",
    "t": 5
  }, {
    "p": [40, 3, 38],
    "s": [27, 4, 4],
    "c": 8551805,
    "t": 5
  }, {
    "p": [40, 3, 22],
    "s": [27, 4, 4],
    "c": 8551805,
    "t": 5
  }, {
    "p": [29, 1, 22],
    "s": [4, 8, 8],
    "c": 1447446,
    "t": 5
  }, {
    "p": [29, 1, 38],
    "s": [4, 8, 8],
    "c": 1447446,
    "t": 5
  }, {
    "p": [34, 1, 38],
    "s": [4, 8, 8],
    "c": 1447446,
    "t": 5
  }, {
    "p": [34, 1, 22],
    "s": [4, 8, 8],
    "c": 1447446,
    "t": 5
  }, {
    "p": [51, 1, 38],
    "s": [4, 8, 8],
    "c": 1447446,
    "t": 5
  }, {
    "p": [46, 1, 38],
    "s": [4, 8, 8],
    "c": 1447446,
    "t": 5
  }, {
    "p": [51, 1, 22],
    "s": [4, 8, 8],
    "c": 1447446,
    "t": 5
  }, {
    "p": [46, 1, 22],
    "s": [4, 8, 8],
    "c": 1447446,
    "t": 5
  }, {
    "p": [40, 12, 97],
    "s": [24, 25, 2],
    "pe": 1,
    "c": "#2c3f55",
    "t": 5
  }, {
    "p": [40, 6, 59],
    "s": [5, 4, 85],
    "c": 8551805,
    "t": 5
  }, {
    "p": [40, 6, -1],
    "s": [24, 4, 3],
    "c": 8551805,
    "t": 5
  }, {
    "p": [47, 12, -2],
    "s": [12, 25, 2],
    "pe": 1,
    "c": "#6b6b6b",
    "t": 5
  }, {
    "p": [26, 12, 3],
    "s": [2, 25, 12],
    "c": "#6b6b6b",
    "t": 5
  }, {
    "p": [40, 5, -1],
    "s": [27, 1, 4],
    "c": 8551805,
    "t": 5
  }, {
    "p": [40, 3, 110],
    "s": [27, 4, 4],
    "c": 8551805,
    "t": 5
  }, {
    "p": [51, 1, 110],
    "s": [4, 8, 8],
    "c": 1447446,
    "t": 5
  }, {
    "p": [29, 1, 110],
    "s": [4, 8, 8],
    "c": 1447446,
    "t": 5
  }, {
    "p": [50, 7, -2],
    "s": [2, 2, 2],
    "l": 1,
    "c": 16730880,
    "e": 16711680,
    "o": 0.8,
    "t": 5
  }, {
    "p": [30, 7, -2],
    "s": [2, 2, 2],
    "l": 1,
    "c": "#ff4b00",
    "e": 16711680,
    "o": 0.8,
    "t": 5
  }, {
    "p": [40, 5, 102],
    "s": [24, 28, 4],
    "c": "#bbbbbb",
    "t": 5
  }, {
    "p": [40, 5, 118],
    "s": [24, 24, 4],
    "c": "#bbbbbb",
    "t": 5
  }, {
    "p": [40, 6, 111],
    "s": [17, 6, 14],
    "c": "#595959",
    "t": 5
  }, {
    "p": [40, 5, 121],
    "s": [25, 6, 3],
    "c": "#5c5c5c",
    "t": 5
  }, {
    "p": [40, 17, 122],
    "s": [22, 10, 1],
    "l": 1,
    "c": "#22272d",
    "t": 5
  }, {
    "p": [40, 11, 121],
    "s": [24, 6, 2],
    "c": "#bbbbbb",
    "t": 5
  }, {
    "p": [40, 17, 121],
    "s": [24, 11, 2],
    "l": 1,
    "c": "#bbbbbb",
    "t": 5
  }, {
    "p": [40, 17, 121],
    "s": [24, 11, 2],
    "v": 1,
    "c": "#213041",
    "t": 5
  }, {
    "p": [50, 12, 122],
    "s": [2, 2, 2],
    "l": 1,
    "e": 16765184,
    "o": 0.8,
    "t": 5
  }, {
    "p": [30, 12, 122],
    "s": [2, 2, 2],
    "l": 1,
    "e": 16765184,
    "o": 0.8,
    "t": 5
  }, {
    "p": [40, 12, 122],
    "s": [14, 4, 2],
    "c": "#6e6e6e",
    "t": 5
  }, {
    "p": [40, 20, 118],
    "s": [28, 4, 1],
    "c": "#6e6e6e",
    "t": 5
  }, {
    "p": [40, 3, 86],
    "s": [22, 6, 22],
    "c": 8551805,
    "t": 5
  }, {
    "p": [30, 12, 100],
    "s": [1, 25, 1],
    "c": "#666666",
    "e": 1579032,
    "t": 5
  }, {
    "p": [50, 12, 100],
    "s": [1, 25, 1],
    "c": "#666666",
    "e": 1579032,
    "t": 5
  }, {
    "p": [40, 8, 49],
    "s": [28, 2, 98],
    "pe": 1,
    "v": 1,
    "c": 2899797,
    "t": 5
  }, {
    "p": [40, 20, 113],
    "s": [25, 8, 8],
    "c": "#22272d",
    "t": 5
  }, {
    "p": [40, 12, 111],
    "s": [24, 18, 14],
    "c": "#bbbbbb",
    "t": 5
  }, {
    "p": [45, 12, 46],
    "s": [6, 2, 92],
    "l": 1,
    "c": 7035206,
    "t": 2
  }, {
    "p": [47, 12, -3],
    "s": [4, 25, 2],
    "i": 3,
    "t": 2,
    "d": 3
  }, {
    "p": [11, 1, 22],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [56, 1, -12],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [23, 1, -12],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [35, 12, 87],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [27, 10, 78],
    "s": [2, 27, 40],
    "pe": 1,
    "c": "#2c3f55",
    "t": 5
  }, {
    "p": [27, 10, 19],
    "s": [2, 27, 42],
    "pe": 1,
    "c": "#2c3f55",
    "t": 5
  }, {
    "p": [53, 10, 89],
    "s": [2, 27, 18],
    "pe": 1,
    "c": "#2c3f55",
    "t": 5
  }, {
    "p": [53, 10, 30],
    "s": [2, 27, 64],
    "pe": 1,
    "c": "#2c3f55",
    "t": 5
  }, {
    "p": [53, 32, 71],
    "s": [1, 5, 18],
    "c": "#ffffff",
    "t": 10
  }, {
    "p": [27, 32, 49],
    "s": [1, 5, 18],
    "c": "#ffffff",
    "t": 10
  }, {
    "p": [53, 10, 71],
    "s": [2, 2, 18],
    "c": "#2c3f55",
    "t": 5
  }, {
    "p": [27, 10, 49],
    "s": [2, 2, 18],
    "c": "#2c3f55",
    "t": 5
  }, {
    "p": [18, 1, 75],
    "s": [6, 2, 92],
    "c": 8678483,
    "t": 2
  }, {
    "p": [11, 1, 74],
    "s": [6, 2, 92],
    "c": 7692103,
    "t": 2
  }, {
    "p": [4, 1, 76],
    "s": [6, 2, 92],
    "c": 5259054,
    "t": 2
  }, {
    "p": [6, 3, 75],
    "s": [6, 2, 92],
    "c": 7692103,
    "t": 2
  }, {
    "p": [14, 3, 76],
    "s": [6, 2, 92],
    "c": 7692103,
    "t": 2
  }, {
    "p": [10, 5, 76],
    "s": [6, 2, 92],
    "c": 7035206,
    "t": 2
  }, {
    "p": [11, 1, 125],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [-34, 0, 61],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [-37, 0, -3],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [-26, 0, 37],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [-26, 0, -44],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [-39, 0, -96],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [-14, 0, -105],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [-5, 0, -102],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [6, 0, -127],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [36, -1, -101],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [60, 0, -124],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [90, 0, -128],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [99, 0, -136],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.79, 0],
    "c": "#d1f777"
  }, {
    "p": [106, 0, -118],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [106, 0, -84],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [85, 0, -29],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [131, -1, -22],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [84, 0, 12],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [131, 0, 27],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [83, 0, 59],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [86, 0, 119],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [158, 0, -153],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [90, 0, 166],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [87, 0, 238],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-27, 0, 237],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-33, 0, 202],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-31, 0, 149],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [-25, 0, 122],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [-69, 0, 174],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-96, 0, 201],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-67, 0, 201],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-170, 0, 201],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-147, 0, 174],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-216, 0, 180],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-216, 0, 172],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-247, 0, 198],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-247, 0, 118],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-180, 0, 68],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-151, 0, 69],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-151, 0, 125],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-243, 0, 50],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-241, 0, 79],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-215, 0, -5],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-184, 0, -46],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-257, 0, -12],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-254, 0, -128],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-218, 0, -88],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-196, 0, -147],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-204, 0, -143],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-134, 0, -149],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-99, 0, -113],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-158, 0, -100],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-35, 0, -153],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-65, 0, -118],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-28, 0, 308],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [103, 0, 279],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [109, 0, 302],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [85, 0, 338],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [94, 0, 362],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [144, 0, 353],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [160, 0, 323],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-26, -1, 381],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-33, -1, 413],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [84, -1, 414],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [133, 0, 69],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [132, 0, 112],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [151, 0, 131],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [189, 0, 132],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [229, 0, 156],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [271, 0, 118],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [286, 0, 156],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [334, 0, 156],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [308, 0, 114],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [308, 0, 59],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [349, 0, 38],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [371, 0, 135],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [395, 0, 116],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [391, 0, 22],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [396, 0, -1],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [307, 0, -18],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [296, 0, -34],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [260, 0, -35],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [260, 0, -72],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [394, 0, -43],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [404, 0, -49],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [429, 0, -60],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [405, 0, -153],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [292, 0, -154],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [206, 0, -125],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [177, 0, -154],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [177, 0, -147],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-10, 0, -108],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [64, 0, -126],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [-287, 0, -54],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [108, -1, 118],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [99, -1, 152],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [124, 0, 151],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [110, 0, 144],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [90, 0, 179],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [88, 0, 264],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-31, 0, 265],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-32, 0, 255],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-33, 0, 223],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [105, -1, 82],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [109, 0, 10],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [95, 0, -62],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [74, -1, -113],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [96, 0, -103],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [136, 0, -148],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [99, 0, -154],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.61, 0],
    "c": "#d1f777"
  }, {
    "p": [170, 0, -126],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [211, 0, -154],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [243, 0, -126],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [262, 0, -152],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [308, 0, -118],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [287, 0, -89],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [325, 0, -36],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [333, 0, -105],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [307, 0, -64],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [359, 0, -76],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [364, 0, -30],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [376, 0, 55],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [358, 0, 113],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [386, 0, 155],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [363, 0, -118],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [378, 0, -148],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [423, 0, -148],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [429, 0, -105],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [405, 0, -98],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [392, 0, -121],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [391, 0, -99],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [391, 0, -79],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [340, 0, 0],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [339, 0, 55],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [338, 0, 86],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-131, 0, 200],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-213, 0, 200],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-171, 0, 172],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-202, 0, 131],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-180, 0, 107],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-211, 0, 70],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-215, 0, 18],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-284, 0, 102],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-260, 0, 102],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-288, 0, 142],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-289, 0, 191],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-264, 0, 202],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-254, 0, 179],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-258, 0, 153],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-183, 2, 46],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-185, 0, 6],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-256, 0, 15],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-255, 0, 38],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-288, 0, 36],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-287, 0, 1],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-287, 0, -30],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-258, 0, -81],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-234, 0, -43],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-208, 0, -44],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-197, 0, -88],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-268, 0, -113],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-278, 0, -139],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-165, 0, -124],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-91, 0, -134],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-47, 0, 350],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-113, 85, -16],
    "s": [137, 10, 159],
    "i": 12,
    "l": 1
  }, {
    "p": [219, 85, 43],
    "s": [170, 10, 146],
    "i": 12,
    "l": 1
  }, {
    "p": [208, 50, -78],
    "s": [93, 10, 87],
    "i": 12,
    "l": 1
  }, {
    "p": [-105, 50, 119],
    "s": [87, 10, 99],
    "i": 12,
    "l": 1
  }, {
    "p": [-89, 103, 411],
    "s": [90, 0, 43],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -3.14],
    "sad": 1
  }, {
    "p": [-318, 74, 96],
    "s": [90, 0, 43],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57],
    "sad": 1
  }, {
    "p": [410, 41, 71],
    "s": [78, 0, 31],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -1.57],
    "sad": 1
  }, {
    "p": [415, -1, 34],
    "s": [4, 62, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [412, 24, 71],
    "s": [2, 34, 82],
    "c": 7692103,
    "t": 5
  }, {
    "p": [415, -1, 108],
    "s": [4, 62, 4],
    "c": 7692103,
    "t": 5
  }, {
    "p": [-320, 50, 97],
    "s": [2, 48, 96],
    "l": 1,
    "c": "#636363",
    "t": 5
  }, {
    "p": [-89, 80, 412],
    "s": [94, 46, 1],
    "l": 1,
    "c": "#636363",
    "t": 5
  }, {
    "p": [33, 102, -146],
    "s": [86, 0, 39],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "sad": 1
  }, {
    "p": [-2, 78, -149],
    "s": [5, 50, 4],
    "l": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [69, 78, -149],
    "s": [5, 50, 4],
    "l": 1,
    "c": 7692103,
    "t": 5
  }, {
    "p": [33, 81, -147],
    "s": [91, 43, 1],
    "c": 7692103,
    "t": 5
  }]
}